import { render, staticRenderFns } from "./Bottle.vue?vue&type=template&id=8ff65936&"
import script from "./Bottle.vue?vue&type=script&lang=js&"
export * from "./Bottle.vue?vue&type=script&lang=js&"
import style0 from "./Bottle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports